<div>
  <app-slip-component-header type="payment" [status]="paymentInfo.status"></app-slip-component-header>
  <hr class="payment-header-separator" />
  <app-student-slip-payment-info
    [status]="paymentInfo.status"
    [amountDue]="paymentInfo.due"
    [balance]="paymentInfo.balance"
    [confirmationPending]="progress.state === PaymentState.ConfirmingPayment"
    [processingPayment]="progress.state !== PaymentState.Initialised">
  </app-student-slip-payment-info>

  <!-- <pre>{{paymentInfo | json}}</pre>
  <pre>{{progress | json}}</pre> -->

  <div class="paymentContainer" [hidden]="!showPaymentForm">
    @if (isHybrid) {
      <div>
        <app-hybrid-payment-form
          [slipInfo]="slipInfo"
          [paymentInfo]="paymentInfo"
          [paymentStatus]="paymentStatus"
          (paymentMethodUpdated)="paymentMethodUpdated.emit($event)"
          (paymentStatusChange)="paymentStatusChange.emit($event)">
        </app-hybrid-payment-form>
      </div>
    }
    @if (!isHybrid) {
      <div>
        <app-web-payment-form
          [slipInfo]="slipInfo"
          [paymentInfo]="paymentInfo"
          [paymentStatus]="paymentStatus"
          (paymentStatusChange)="paymentStatusChange.emit($event)">
        </app-web-payment-form>
      </div>
    }
  </div>
  @switch (progress.state) {
    @case (PaymentState.ProcessingPayment) {
      <span class="processingPayment">
        <div class="contentWrapper">
          <div class="imageSpinnerCont">
            <ion-spinner name="crescent"></ion-spinner>
          </div>
          <div class="textCont">
            <p class="header">Processing payment</p>
            <p class="subHeader">PLEASE WAIT</p>
          </div>
        </div>
      </span>
    }
    @case (PaymentState.ConfirmingPayment) {
      <span class="paymentSuccess" [@slideUpFadeInWithChild]>
        <div class="contentWrapper">
          <div class="imageSpinnerCont">
            <img src="/assets/icon/tick-icon-green.svg" />
          </div>
          <div class="textCont">
            <p class="header">
              {{ progress.paymentStatus.method === 'google' ? 'Success! Paid with Google' : 'Payment success!' }}
            </p>
            <p class="subHeader" [@delayedSlideUpFadeIn]>
              <ion-spinner name="crescent"></ion-spinner> CONFIRMATION PENDING
            </p>
          </div>
        </div>
      </span>
    }
    @case (PaymentState.PaymentConfirmed) {
      <span class="paymentConfirmed" [@slideUpFadeIn]>
        <div class="contentWrapper">
          <div class="imageSpinnerCont">
            <img src="/assets/icon/tick-icon-green.svg" />
          </div>
          <div class="textCont">
            <p class="header">
              {{ progress.paymentStatus.method === 'google' ? 'Paid with Google Pay' : 'Payment confirmed!' }}
            </p>
            <p class="subHeader" [@delayedSlideUpFadeIn]>WE'VE EMAILED YOU A RECEIPT</p>
          </div>
        </div>
      </span>
    }
  }
</div>
